import animateScrollTo from 'animated-scroll-to';

function promptLogin(selector = 'loginLink', emailSelector = 'emailLoginPopover') {
  animateScrollTo(0);
  document.getElementById(selector).click();
  document.getElementById(emailSelector).focus();
}

export default promptLogin;
